import { render, staticRenderFns } from "./OnboardingNextSteps.vue?vue&type=template&id=984d9576&scoped=true"
import script from "./OnboardingNextSteps.vue?vue&type=script&lang=js"
export * from "./OnboardingNextSteps.vue?vue&type=script&lang=js"
import style0 from "./OnboardingNextSteps.vue?vue&type=style&index=0&id=984d9576&prod&lang=scss&scoped=true"
import style1 from "./OnboardingNextSteps.vue?vue&type=style&index=1&id=984d9576&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984d9576",
  null
  
)

export default component.exports